module.exports = __webpack_public_path__ + "media/images/ui-icons_777777_256x240-c29a67a006dbb7eaae4bf592e5586e71.png";